// Nguồn màu sắc / thương hiệu dùng chung cho toàn bộ app.
// Đổi ở đây sẽ áp dụng lại cho Login, Sidebar, Header, theme AntD.

export const brandName = 'Thẩm Mỹ Hằng Pooh';
export const brandTagline = 'Chăm sóc da & quản lý liệu trình';

export const colors = {
  primary: '#D6708D',
  primaryHover: '#C25777',
  primaryActive: '#AD4767',
  primarySoft: '#F7E3E9',

  bgLayout: '#FFF7F9',
  bgCard: '#FFFFFF',

  sidebarBg: '#3A2430',
  sidebarBgActive: '#D6708D',
  sidebarText: 'rgba(255,255,255,0.75)',
  sidebarTextActive: '#FFFFFF',

  textHeading: '#3A2430',
  textBody: '#5B4A52',

  border: '#F0DDE3',

  success: '#3AA76D',
  warning: '#D99A3D',
  danger: '#D64550',
};

export const radius = {
  base: 10,
  sm: 6,
  lg: 16,
};

export const fontFamily = "'Be Vietnam Pro', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";
